import script from "./TagList.vue?vue&type=script&setup=true&lang=js"
export * from "./TagList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"TagList.vue"]])

export default __exports__